export default __webpack_public_path__ + "static/media/activesurfacewave.92983499.png";